import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import parse from "html-react-parser";
import genConfig from "../config/GeneralConfig.json";
import "./HomeContent.css";
import LeftColomn from "./LeftColomn";
import McCarousel from "./McCarousel";
import Wrapper from "../Helpers/Wrapper";

const HomeContent = () => {
  const divOpacityValue = "0.7";
  const divBkgrndValue = "#ECECEC";
  const [width, setWidth] = useState(window.innerWidth);
  const breakPoint = 991;

  const [htmlFileString, setHtmlFileString] = useState();
  const [jsonConfig, setJsonConfig] = useState();


  async function fetchHtml() {
    setHtmlFileString(
      await (await fetch(`/staticData/homeContent.html`)).text()
    );
  };

  async function fetchConfig() {
    setJsonConfig(
      await (await fetch(`/staticData/GeneralConfig.json`)).json()
    );
  }

  useEffect(() => {
    fetchHtml();
    fetchConfig();
  }, []);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <Wrapper>
      {width > breakPoint ? (
        <Row>
          <Col lg={3} className="gy-3">
            <LeftColomn />
          </Col>
          <Col lg={9} className="gy-3">
            <McCarousel />
            <Row>
              <div>
                {htmlFileString ? (
                  parse(htmlFileString)
                ) : (
                  <p>
                    <strong>LOADING... Please wait</strong>
                  </p>
                )}
              </div>
              {/* <strong>{genConfig.presidentName} - MCMTA President</strong> */}
              <strong>{jsonConfig && jsonConfig.presidentName} - MCMTA President</strong>
            </Row>
          </Col>
        </Row>
      ) : (
        <Row>
          <Col lg={9} className="gy-3">
            <McCarousel />
            <Row>
              <div>
                {htmlFileString ? (
                  parse(htmlFileString)
                ) : (
                  <p>
                    <strong>LOADING... Please wait</strong>
                  </p>
                )}
              </div>
              {/* <strong>{genConfig.presidentName} - MCMTA President</strong> */}
              <strong>{jsonConfig && jsonConfig.presidentName} - MCMTA President</strong>
            </Row>
          </Col>
          <Col lg={3} className="gy-3">
            <LeftColomn />
          </Col>
        </Row>
      )}
    </Wrapper>
  );
};

export default HomeContent;
